/* RK Licht — core interactions. No dependencies. Progressive enhancement: everything works without this file. */
(() => {
  const RK = window.RK || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  RK.reduced = reduced;

  /* ---------- toast ---------- */
  let toastTimer;
  RK.toast = (msg) => {
    const t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { t.hidden = true; }, 3200);
  };

  /* ---------- drawers (menu, cart, filters) with focus trap ---------- */
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select, textarea, summary, [tabindex]:not([tabindex="-1"])';
  let lastFocus = null;
  RK.openDrawer = (id, opener) => {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = opener || document.activeElement;
    d.classList.add('is-open');
    document.documentElement.classList.add('has-drawer');
    $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const first = $$(FOCUSABLE, $('.drawer__panel', d)).find((el) => el.offsetParent !== null);
    setTimeout(() => (first || d).focus({ preventScroll: true }), 60);
  };
  RK.closeDrawer = (d) => {
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('has-drawer');
    $$(`[aria-controls="${d.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  };
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); RK.openDrawer(open.dataset.drawerOpen, open); return; }
    const close = e.target.closest('[data-drawer-close]');
    if (close) { e.preventDefault(); RK.closeDrawer(close.closest('[data-drawer]')); }
  });
  document.addEventListener('keydown', (e) => {
    const d = $('[data-drawer].is-open');
    if (e.key === 'Escape') {
      if (d) { RK.closeDrawer(d); return; }
      closeMegas(true);
      closeSearch(true);
      const qa = $('details[data-qa][open]');
      if (qa) { qa.removeAttribute('open'); qa.querySelector('summary')?.focus(); }
    }
    if (e.key === 'Tab' && d) {
      const els = $$(FOCUSABLE, d).filter((el) => el.offsetParent !== null);
      if (!els.length) return;
      const first = els[0];
      const last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- header: scrolled state, mega menu ---------- */
  const header = $('[data-header]');
  const hsec = header?.closest('.header-section') || header;
  if (header) {
    const root = document.documentElement;
    let hH = 72;
    let lastY = window.scrollY;
    const measure = () => { hH = hsec.offsetHeight; if (!root.classList.contains('hdr-hide')) root.style.setProperty('--header-h', `${hH}px`); };
    const busy = () => !!document.querySelector('[data-drawer].is-open, .mega.is-open, [data-search-pop]:not([hidden]), details[data-qa][open]');
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      if (y > 320 && y > lastY + 6 && !busy()) {
        if (!root.classList.contains('hdr-hide')) { root.classList.add('hdr-hide'); root.style.setProperty('--header-h', '0px'); }
      } else if (y < lastY - 6 || y <= 320) {
        if (root.classList.contains('hdr-hide')) { root.classList.remove('hdr-hide'); root.style.setProperty('--header-h', `${hH}px`); }
      }
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(hsec); else window.addEventListener('resize', measure);
    measure();
    onScroll();
    header.addEventListener('focusin', () => { root.classList.remove('hdr-hide'); root.style.setProperty('--header-h', `${hH}px`); });
  }
  function closeMegas(returnFocus) {
    $$('[data-mega-btn][aria-expanded="true"]').forEach((b) => {
      b.setAttribute('aria-expanded', 'false');
      document.getElementById(b.getAttribute('aria-controls'))?.classList.remove('is-open');
      if (returnFocus) b.focus();
    });
  }
  let megaTimer;
  $$('[data-mega-btn]').forEach((btn) => {
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    const open = () => {
      clearTimeout(megaTimer);
      if (btn.getAttribute('aria-expanded') === 'true') return;
      closeMegas(false);
      closeSearch(false);
      btn.setAttribute('aria-expanded', 'true');
      panel.classList.add('is-open');
    };
    btn.addEventListener('click', () => {
      if (btn.getAttribute('aria-expanded') === 'true') closeMegas(false); else open();
    });
    if (window.matchMedia('(hover: hover)').matches) {
      const li = btn.closest('.nav__item');
      li.addEventListener('mouseenter', () => { megaTimer = setTimeout(open, 90); });
      li.addEventListener('mouseleave', () => { clearTimeout(megaTimer); megaTimer = setTimeout(() => closeMegas(false), 160); });
    }
    panel.addEventListener('focusout', (e) => {
      if (!btn.closest('.nav__item').contains(e.relatedTarget)) closeMegas(false);
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav__item')) closeMegas(false);
    if (!e.target.closest('[data-search-pop]') && !e.target.closest('[data-search-open]')) closeSearch(false);
  });

  /* ---------- search pop + predictive search (JSON API) ---------- */
  const searchPop = $('[data-search-pop]');
  const searchBtn = $('[data-search-open]');
  function closeSearch(returnFocus) {
    if (!searchPop || searchPop.hidden) return;
    searchPop.hidden = true;
    searchBtn?.setAttribute('aria-expanded', 'false');
    if (returnFocus) searchBtn?.focus();
  }
  searchBtn?.addEventListener('click', (e) => {
    if (!searchPop) return;
    e.preventDefault();
    if (!searchPop.hidden) { closeSearch(false); return; }
    closeMegas(false);
    searchPop.hidden = false;
    searchBtn.setAttribute('aria-expanded', 'true');
    $('input[type=search]', searchPop)?.focus();
  });

  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  RK.formatMoney = (cents) => {
    const fmt = RK.moneyFormat || '{{amount_with_comma_separator}} €';
    const v = (Number(cents) / 100).toFixed(2);
    const [i, d] = v.split('.');
    const dots = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const commas = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: `${commas}.${d}`, amount_no_decimals: commas, amount_with_comma_separator: `${dots},${d}`,
      amount_no_decimals_with_comma_separator: dots, amount_with_apostrophe_separator: `${i.replace(/\B(?=(\d{3})+(?!\d))/g, "'")}.${d}`
    }[k] || `${dots},${d}`)).replace(/<[^>]*>/g, '');
  };
  const money = (cents) => RK.formatMoney(cents);
  const mark = (text, q) => {
    const safe = esc(text);
    const words = q.trim().split(/\s+/).filter((w) => w.length > 1).map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    if (!words.length) return safe;
    // whole words only (no highlighting inside compound words)
    const re = new RegExp('(^|[\\s(\\-–])(' + words.join('|') + ')(?=$|[\\s,.)\\-–])', 'gi');
    return safe.replace(re, '$1<mark>$2</mark>');
  };
  $$('[data-predict-form]').forEach((form) => {
    const input = $('[data-predict-input]', form);
    const out = document.getElementById(input.getAttribute('aria-controls'));
    if (!out) return;
    let ctrl;
    let timer;
    const strings = (out.dataset.strings && JSON.parse(out.dataset.strings)) || null;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
      timer = setTimeout(async () => {
        ctrl?.abort();
        ctrl = new AbortController();
        try {
          const url = new URL('/search/suggest.json', location.origin);
          url.searchParams.set('q', q);
          url.searchParams.set('resources[type]', 'product,collection,page,query');
          url.searchParams.set('resources[limit]', '6');
          url.searchParams.set('resources[options][unavailable_products]', 'last');
          const r = await fetch(url, { signal: ctrl.signal });
          const j = await r.json();
          const res = j.resources?.results || {};
          const products = (res.products || []).filter((p) => !/shipping-protection/.test(p.handle));
          const cols = res.collections || [];
          const queries = res.queries || [];
          const L = RK.searchStrings || {};
          let html = '<div class="predict__grid">';
          html += '<div>';
          if (queries.length) {
            html += `<p class="predict__title">${esc(L.suggestions)}</p><ul class="predict__terms" role="list">${queries.slice(0, 5).map((s) => `<li><a href="${esc(s.url)}">${esc(s.text)}</a></li>`).join('')}</ul>`;
          }
          if (cols.length) {
            html += `<p class="predict__title" style="margin-top:16px">${esc(L.collections)}</p><ul class="predict__terms" role="list">${cols.slice(0, 5).map((c) => `<li><a href="${esc(c.url)}">${esc(c.title)}</a></li>`).join('')}</ul>`;
          }
          html += '</div><div>';
          if (products.length) {
            html += `<p class="predict__title">${esc(L.products)}</p><ul class="predict__list" role="listbox" aria-label="${esc(L.products)}">`;
            html += products.map((p) => {
              const sale = Number(p.compare_at_price_max) > Number(p.price);
              const img = p.featured_image?.url ? `<img src="${esc(p.featured_image.url)}&width=120" alt="" width="56" height="56" loading="lazy">` : '<span></span>';
              return `<li role="option"><a class="predict__item" href="${esc(p.url)}">${img}<span><span class="predict__name">${mark(p.title, q)}</span><span class="predict__price"><span class="${sale ? 'is-sale' : ''}">${money(Math.round(Number(p.price) * 100))}</span>${sale ? ` <s>${money(Math.round(Number(p.compare_at_price_max) * 100))}</s>` : ''}</span></span></a></li>`;
            }).join('');
            html += '</ul>';
          } else {
            html += `<p class="muted">${esc((L.none || '').replace('%TERMS%', q))}</p>`;
          }
          html += `<p class="predict__all"><a class="btn btn--ghost btn--sm" href="${form.action}?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last">${esc((L.all || '').replace('%TERMS%', q))}</a></p>`;
          html += '</div></div>';
          out.innerHTML = html;
          input.setAttribute('aria-expanded', 'true');
        } catch (err) {
          if (err.name !== 'AbortError') out.innerHTML = '';
        }
      }, 180);
    });
    input.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowDown') return;
      const first = $('a', out);
      if (first) { e.preventDefault(); first.focus(); }
    });
    out.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      const links = $$('a', out);
      const i = links.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      const next = e.key === 'ArrowDown' ? links[i + 1] : links[i - 1];
      (next || input).focus();
    });
  });

  /* ---------- cart ---------- */
  const cartSectionEl = document.querySelector('[data-cart-section]');
  const SECTION = cartSectionEl ? cartSectionEl.dataset.cartSection : 'cart-drawer';
  const FALLBACK = cartSectionEl ? cartSectionEl.dataset.cartFallback : RK.routes.root;
  const countEls = () => $$('[data-cart-count]');
  function setCount(n, bump) {
    countEls().forEach((el) => {
      el.dataset.count = n;
      el.textContent = n > 0 ? n : '';
      if (bump && !reduced) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }
  async function swapDrawer(html) {
    let src = html;
    if (!src || !src.includes('data-cart-root')) {
      // Dev-preview quirk: Section Rendering can come back from another theme; fall back to a full page render.
      const r = await fetch(FALLBACK, { credentials: 'same-origin' });
      src = await r.text();
    }
    const doc = new DOMParser().parseFromString(src, 'text/html');
    const fresh = doc.querySelector('[data-cart-root]');
    const cur = $('[data-cart-root]');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
  }
  RK.refreshCart = async (sectionsHtml) => {
    try {
      await swapDrawer(sectionsHtml);
      const c = await (await fetch('/cart.js')).json();
      setCount(c.item_count, false);
      return c;
    } catch (e) { return null; }
  };
  function fly(fromImg) {
    if (reduced || !fromImg) return;
    const target = $('[data-cart-open]');
    if (!target) return;
    const a = fromImg.getBoundingClientRect();
    const b = target.getBoundingClientRect();
    if (!a.width) return;
    const clone = document.createElement('img');
    clone.src = fromImg.currentSrc || fromImg.src;
    clone.className = 'fly';
    clone.alt = '';
    const size = 72;
    clone.style.left = `${a.left + a.width / 2 - size / 2}px`;
    clone.style.top = `${a.top + a.height / 2 - size / 2}px`;
    document.body.appendChild(clone);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const anim = clone.animate([
      { transform: 'translate(0,0) scale(1.4)', opacity: 0 },
      { transform: 'translate(0,-10px) scale(1.2)', opacity: 1, offset: 0.15 },
      { transform: `translate(${dx}px, ${dy}px) scale(0.25)`, opacity: 0.6 }
    ], { duration: 720, easing: 'cubic-bezier(.5,0,.2,1)' });
    anim.onfinish = () => clone.remove();
  }
  RK.addToCart = async (form, opts = {}) => {
    const btn = form.querySelector('[type=submit]');
    btn?.classList.add('is-loading');
    btn?.setAttribute('aria-busy', 'true');
    try {
      const fd = new FormData(form);
      fd.append('sections', SECTION);
      fd.append('sections_url', location.pathname);
      const r = await fetch(`${RK.routes.cartAdd}.js`, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      const j = await r.json();
      if (!r.ok || j.status) throw new Error(j.description || j.message || RK.strings.error);
      fly(opts.img || form.closest('[data-card]')?.querySelector('.card__img--main') || $('.gallery__img'));
      if (RK.cartType === 'page') { location.href = RK.routes.cart; return; }
      await swapDrawer(j.sections && j.sections[SECTION]);
      const c = await (await fetch('/cart.js')).json();
      setCount(c.item_count, true);
      form.closest('details')?.removeAttribute('open');
      RK.openDrawer('cart-drawer', btn);
      document.dispatchEvent(new CustomEvent('cart:added', { detail: j }));
    } catch (err) {
      RK.toast(err.message || RK.strings.error);
    } finally {
      btn?.classList.remove('is-loading');
      btn?.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-quick-add], form[data-product-form]');
    if (!form || !$('#cart-drawer') && RK.cartType !== 'page') return;
    e.preventDefault();
    RK.addToCart(form);
  });
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cart-open]');
    if (open && $('#cart-drawer')) { e.preventDefault(); RK.openDrawer('cart-drawer', open); }
  });

  async function changeLine(line, quantity) {
    const root = $('[data-cart-root]');
    root?.setAttribute('aria-busy', 'true');
    root?.classList.add('is-busy');
    try {
      const r = await fetch(`${RK.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: [SECTION], sections_url: location.pathname })
      });
      const j = await r.json();
      if (!r.ok || j.status) throw new Error(j.description || j.message || RK.strings.error);
      await swapDrawer(j.sections && j.sections[SECTION]);
      setCount(j.item_count, false);
      const focusTarget = $(`[data-cart-root] [data-line="${line}"] [data-qty-input]`) || $('[data-cart-root] .drawer__title');
      if (focusTarget) { focusTarget.setAttribute('tabindex', focusTarget.tabIndex < 0 ? '-1' : focusTarget.tabIndex); focusTarget.focus({ preventScroll: true }); }
    } catch (err) {
      RK.toast(err.message || RK.strings.error);
    } finally {
      root?.removeAttribute('aria-busy');
      root?.classList.remove('is-busy');
    }
  }
  document.addEventListener('click', (e) => {
    const root = e.target.closest('[data-cart-root]');
    if (!root) return;
    const step = e.target.closest('[data-qty-step]');
    const rm = e.target.closest('[data-line-remove]');
    const lineEl = e.target.closest('[data-line]');
    if (!lineEl || (!step && !rm)) return;
    e.preventDefault();
    const input = $('[data-qty-input]', lineEl);
    const q = rm ? 0 : Math.max(0, Number(input.value) + Number(step.dataset.qtyStep));
    changeLine(Number(lineEl.dataset.line), q);
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-root] [data-qty-input]');
    if (!input) return;
    changeLine(Number(input.closest('[data-line]').dataset.line), Math.max(0, Number(input.value)));
  });

  /* ---------- announcement rotation + countdown ---------- */
  const ann = $('[data-announce]');
  if (ann) {
    const items = $$('.announce__item', ann);
    if (items.length > 1 && !reduced) {
      let i = Math.max(0, items.findIndex((x) => x.classList.contains('is-active')));
      setInterval(() => {
        if (window.innerWidth >= 1000 || document.hidden) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4500);
    }
    const cd = $('[data-countdown]', ann);
    if (cd) {
      const end = Date.parse(cd.dataset.countdown);
      const out = $('[data-cd]', cd);
      const tick = () => {
        const ms = end - Date.now();
        if (!(ms > 0)) { cd.hidden = true; return false; }
        const d = Math.floor(ms / 864e5);
        const h = Math.floor((ms % 864e5) / 36e5);
        const m = Math.floor((ms % 36e5) / 6e4);
        out.textContent = `${d} T ${String(h).padStart(2, '0')} Std ${String(m).padStart(2, '0')} Min`;
        cd.hidden = false;
        return true;
      };
      if (tick()) setInterval(tick, 30000);
    }
  }

  /* ---------- reveals + seams (IntersectionObserver, CSS transitions) ---------- */
  const revealEls = $$('[data-reveal], .seam[data-sew], [data-count-up]');
  if ('IntersectionObserver' in window && !reduced) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        if (en.target.hasAttribute('data-count-up')) countUp(en.target);
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-in'));
  }
  function countUp(el) {
    const to = Number(el.dataset.countUp);
    if (!to) return;
    const t0 = performance.now();
    const dur = 1100;
    const step = (t) => {
      const p = Math.min(1, (t - t0) / dur);
      el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  /* ---------- view transition: tag the clicked card image ---------- */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-card-link]');
    if (!link) return;
    const img = link.closest('[data-card]')?.querySelector('.card__img--main');
    if (img) img.style.viewTransitionName = 'product-media';
  });
  window.addEventListener('pageshow', () => { $$('.card__img--main').forEach((i) => { i.style.viewTransitionName = ''; }); });

  /* ---------- horizontal scrollers: prev/next buttons (desktop) ---------- */
  $$('[data-scroller-nav]').forEach((nav) => {
    const sec = nav.closest('section, .rail-sec, .section') || nav.parentElement;
    const sc = sec.querySelector('[data-scroller]');
    if (!sc) return;
    const btns = $$('[data-scroll]', nav);
    const upd = () => {
      btns[0].disabled = sc.scrollLeft <= 4;
      btns[1].disabled = sc.scrollLeft >= sc.scrollWidth - sc.clientWidth - 4;
    };
    btns.forEach((b) => b.addEventListener('click', () => {
      sc.dispatchEvent(new Event('pointerdown'));
      sc.scrollBy({ left: Number(b.dataset.scroll) * sc.clientWidth * 0.8, behavior: reduced ? 'auto' : 'smooth' });
    }));
    sc.addEventListener('scroll', upd, { passive: true });
    upd();
  });

  /* ---------- policy pages: table of contents from headings ---------- */
  const pol = $('.shopify-policy__body');
  const polTitle = $('.shopify-policy__title');
  if (polTitle && RK.strings.legal) {
    const eb = document.createElement('p');
    eb.className = 'eyebrow';
    eb.textContent = RK.strings.legal;
    polTitle.prepend(eb);
  }
  if (pol) {
    const hs = $$('h2, h3', pol).filter((h) => h.textContent.trim().length > 2);
    if (hs.length >= 3) {
      const det = document.createElement('details');
      det.className = 'toc';
      const sum = document.createElement('summary');
      sum.textContent = RK.strings.toc || 'Inhalt';
      const ol = document.createElement('ol');
      hs.forEach((h, i) => {
        h.id = h.id || `abschnitt-${i + 1}`;
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${h.id}`;
        a.textContent = h.textContent.trim().replace(/[:：]\s*$/, '');
        li.appendChild(a);
        ol.appendChild(li);
      });
      det.append(sum, ol);
      if (window.innerWidth >= 1000) det.open = true;
      pol.prepend(det);
    }
  }

  document.addEventListener('click', (e) => {
    const c = e.target.closest('[data-qa-close]');
    if (c) { e.preventDefault(); const d = c.closest('details'); d?.removeAttribute('open'); d?.querySelector('summary')?.focus(); }
  });

  /* ---------- details: close quick-add on outside click ---------- */
  document.addEventListener('click', (e) => {
    $$('details[data-qa][open]').forEach((d) => { if (!d.contains(e.target) || e.target === d) d.removeAttribute('open'); });
  });

  /* ---------- load motion layer after the page (LCP) is done ---------- */
  if (RK.motion && !reduced && document.querySelector('[data-motion]')) {
    const load = (src) => new Promise((res, rej) => { const s = document.createElement('script'); s.src = src; s.onload = res; s.onerror = rej; document.head.appendChild(s); });
    const start = () => load(RK.assets.gsap).then(() => load(RK.assets.st)).then(() => load(RK.assets.motion)).catch(() => {});
    const idle = (fn) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 2500 }) : setTimeout(fn, 600));
    if (document.readyState === 'complete') idle(start); else window.addEventListener('load', () => idle(start), { once: true });
  }
})();
